<template>
  <base-recommendations v-bind="$attrs">
    <template
      #recommendation-item="{
        template,
        item,
        queryId,
        source,
        layout,
        index,
        primaryKey,
        recommendationClick
      }"
    >
      <recommendation-item
        :template="template"
        :item="item"
        :query-id="queryId"
        :source="source"
        :layout="layout"
        :index="index"
        :primary-key="primaryKey"
        @recommendation-click="recommendationClick"
      ></recommendation-item>
    </template>
  </base-recommendations>
</template>

<script>
import { BaseRecommendations } from '@mezereon/ui-components-vue'
import RecommendationItem from './RecommendationItem.vue'

export default {
  name: 'MzShopifyRecommendations',
  components: {
    BaseRecommendations,
    RecommendationItem
  },
  inheritAttrs: false
}
</script>
